import { useQuery } from '@tanstack/react-query'
import instance from '../api'
import { BillingInformation } from '../../interfaces/billingInformation'
import { useAuthContext } from '../../context/auth/auth'

// The endpoint lists the caller's own billing addresses, of which there is at
// most one. An account provisioned outside checkout has none, and react-query
// v4 rejects a query that resolves to `undefined` - it would have been thrown,
// retried three times and finally reported as a load failure. "No billing
// address" is a real answer, so it is an explicit null.
const getBillingInformation = async (
  token: string,
): Promise<BillingInformation | null> => {
  const response = await instance.get('/auth/billing-address/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data.data?.[0] ?? null
}

const useBillingInformation = () => {
  const { token } = useAuthContext()
  return useQuery({
    queryKey: ['billingInformation'],
    queryFn: () => getBillingInformation(token!),
  })
}

export default useBillingInformation
